export default {
  title_1: '操作説明',
  operation_desc_1: 'アルミ合金シェルがウォレットを損傷から保護します',
  operation_desc_2: 'LEFT ボタン',
  operation_desc_3: '画面内で左に移動／前のページへ戻る',
  operation_desc_4: 'DOWN ボタン',
  operation_desc_5: '画面内で下に移動',
  operation_desc_6: '2インチディスプレイ：関連する取引を表示',
  operation_desc_7: 'UP ボタン',
  operation_desc_8: '画面内で上に移動',
  operation_desc_9: 'RIGHT ボタン',
  operation_desc_10: '画面内で右に移動／操作を確定',
  operation_desc_11: 'OK ボタン',
  operation_desc_12: '操作を確定、またはメニュー画面に入る。長押しで電源オン／オフ',
  operation_desc_13: 'Type-C',
  operation_desc_14: '充電およびファームウェア更新用',

  title_2: 'KeyPal の始め方',
  get_start_desc_1: '初期化',
  get_start_desc_2: '「',
  get_start_desc_3: '」ボタンを3秒長押しして電源オン。KP_XXX が未アクティベートと表示されます。',
  get_start_desc_4: '有効化手順（ウォレット作成）：',
  get_start_desc_5: '1. クリックして',
  get_start_desc_6: 'メインメニューに入ります。',
  get_start_desc_7: '2. DOWN ボタンを押して',
  get_start_desc_8: '「Create Wallet」を選択',
  get_start_desc_9: '3. ニーモニックを順番にバックアップ・確認し、PIN コードを設定します。これでデバイスが有効化されます。',
  get_start_desc_10: '記録には紙とペン、または KEYPAL ニーモニックボックスをご利用ください。',
  get_start_desc_11: 'ニーモニックは順番に記録し、検証してください',

  title_3: 'KeyPal を TokenPocket に接続する方法',
  connect_desc_1: '1. KeyPal の Bluetooth をオンにします：[設定] - [Bluetooth]。',
  connect_desc_2: '2. TokenPocket で右上のウォレット「',
  connect_desc_3: '」をタップし、「ネットワーク選択」ページで KeyPal ハードウェアウォレットを選択。',
  connect_desc_4: '3. 「デバイス追加」を選択。TokenPocket がデバイスを検索し、現在の Bluetooth 名に一致するデバイスを選びます。',
  connect_desc_4_2: '（注意：Bluetooth 名は［概要］-［デバイス情報］で確認できます。見つからない場合はハードウェアを再起動して、接続手順を繰り返してください。',
  connect_desc_5: '接続に成功すると、TokenPocket 資産ページ右上に KeyPal の Bluetooth アイコンが表示されます。',
  connect_desc_6: '接続成功',

  title_4: 'ウォレットを一括作成',
  batch_desc_1: '1. Bluetooth で KeyPal を TokenPocket アプリに接続します。',
  batch_desc_2: '2. アプリ右上の Bluetooth マーク付きハードウェアウォレットアイコンをタップ。',
  batch_desc_3: '3. 「KeyPal 管理」→「ウォレットを追加」。',
  batch_desc_4: '4. 画面右上の「一括追加」をタップして完了。',
  batch_desc_5: 'KeyPal と TokenPocket の接続方法は上記を参照',
  batch_desc_6: '一括ウォレットを表示',

  title_5: '交換・送金など：PIN コードで署名',
  exchange_desc_1: 'KeyPal を TokenPocket アプリに接続して、以下の操作を行います：',
  exchange_desc_2: '画像では、1行目右端の画像に表示される「*」は、2行目2枚目の画像の数字に対応します。KeyPal に表示される数字に従い、ウォレット作成時に設定した PIN を入力してください。',
  exchange_desc_3: 'KeyPal に表示される数字の位置に従って、クライアント側で入力してください',

  tutorial_title_1: 'KeyPal デバイスを検証するには？',
  tutorial_desc_1: 'デバイス管理に入り、デバイスのセキュリティを確認します。',
  tutorial_title_2: 'あなたのアドレスが KeyPal に属するか確認するには？',
  tutorial_desc_2: 'KeyPal を TokenPocket に接続し、「Receive」→「Test」を順に選択します。',
  tutorial_title_3: 'KeyPal でトークンを受け取るには？',
  tutorial_desc_3: 'KeyPal を TokenPocket に接続し、「Receive」を選択します。',
  tutorial_title_4: 'KeyPal でトークンを送るには？',
  tutorial_desc_4: 'KeyPal を TokenPocket に接続し、「Send」と「Transfer」を選択します。',
  tutorial_title_5: '取引時に PIN コードを入力する方法は？',
  tutorial_desc_5: ''
};
